<template>
  <div class="ctrl-login">
    <div class="wrap">
      <CtrlProductProducts :categoryId="categoryId" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CtrlProductProducts from "@/components/Ctrl/Product/Products.vue";
export default {
  name: "ctrl-login",
  components: {
    CtrlProductProducts,
  },
  props: {
    categoryId: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
</style>
